module.exports = __webpack_public_path__ + "img/chat.dd0a9055.svg";